
export enum RecommendationType
{
    Job = 1,
    Company = 2,
    Candidate = 3
}